var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30, _clipPath31, _clipPath32, _clipPath33, _clipPath34, _clipPath35, _clipPath36, _clipPath37, _clipPath38, _clipPath39, _clipPath40, _clipPath41, _clipPath42, _clipPath43, _clipPath44, _clipPath45, _clipPath46, _clipPath47, _clipPath48, _clipPath49, _clipPath50, _clipPath51, _clipPath52, _clipPath53, _clipPath54, _clipPath55, _clipPath56, _clipPath57, _clipPath58, _clipPath59, _clipPath60, _clipPath61, _clipPath62, _clipPath63, _clipPath64, _clipPath65, _clipPath66, _clipPath67, _clipPath68, _clipPath69, _clipPath70, _clipPath71, _clipPath72, _clipPath73, _clipPath74, _clipPath75, _clipPath76, _clipPath77, _clipPath78, _clipPath79, _clipPath80, _clipPath81, _clipPath82, _clipPath83, _clipPath84, _clipPath85, _clipPath86, _clipPath87, _clipPath88, _clipPath89, _clipPath90, _clipPath91, _clipPath92, _clipPath93, _clipPath94, _clipPath95, _clipPath96, _clipPath97, _clipPath98, _clipPath99, _clipPath100, _clipPath101, _clipPath102, _clipPath103, _clipPath104, _clipPath105, _clipPath106, _clipPath107, _clipPath108, _clipPath109, _clipPath110, _clipPath111, _clipPath112, _clipPath113, _clipPath114, _clipPath115, _clipPath116, _clipPath117, _clipPath118, _clipPath119, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _use93, _use94, _use95, _use96, _use97, _use98, _use99, _use100, _use101, _use102, _use103, _use104, _use105, _use106, _use107, _use108, _use109, _use110, _use111, _use112, _use113, _use114, _use115, _use116, _use117, _use118, _use119;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDielectricConstant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 81.164062 4.207031 C 81.695312 4.476562 81.695312 4.476562 81.164062 4.207031 Z M 81.164062 4.207031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 51.503906 6.210938 C 52.039062 6.480469 52.039062 6.480469 51.503906 6.210938 Z M 51.503906 6.210938 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 107.613281 6.613281 C 108.148438 6.878906 108.148438 6.878906 107.613281 6.613281 Z M 107.613281 6.613281 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 162.523438 8.617188 C 163.058594 8.882812 163.058594 8.882812 162.523438 8.617188 Z M 162.523438 8.617188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 31.0625 9.820312 C 31.597656 10.085938 31.597656 10.085938 31.0625 9.820312 Z M 31.0625 9.820312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 15.429688 13.828125 C 15.964844 14.09375 15.964844 14.09375 15.429688 13.828125 Z M 15.429688 13.828125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 83.167969 18.238281 C 83.699219 18.503906 83.699219 18.503906 83.167969 18.238281 Z M 83.167969 18.238281 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 83.167969 21.042969 C 83.699219 21.308594 83.699219 21.308594 83.167969 21.042969 Z M 83.167969 21.042969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 151.300781 24.25 C 151.835938 24.515625 151.835938 24.515625 151.300781 24.25 Z M 151.300781 24.25 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface32",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 138.074219 32.265625 C 138.609375 32.53125 138.609375 32.53125 138.074219 32.265625 Z M 138.074219 32.265625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 87.574219 33.867188 C 88.109375 34.136719 88.109375 34.136719 87.574219 33.867188 Z M 87.574219 33.867188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 57.515625 34.667969 C 58.050781 34.9375 58.050781 34.9375 57.515625 34.667969 Z M 57.515625 34.667969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface41",
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 129.660156 38.277344 C 130.195312 38.542969 130.195312 38.542969 129.660156 38.277344 Z M 129.660156 38.277344 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface44",
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 71.945312 41.882812 C 72.476562 42.152344 72.476562 42.152344 71.945312 41.882812 Z M 71.945312 41.882812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface47",
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 118.835938 51.503906 C 119.371094 51.769531 119.371094 51.769531 118.835938 51.503906 Z M 118.835938 51.503906 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface50",
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 162.523438 53.105469 C 163.058594 53.375 163.058594 53.375 162.523438 53.105469 Z M 162.523438 53.105469 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface53",
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 195.792969 56.3125 C 196.324219 56.578125 196.324219 56.578125 195.792969 56.3125 Z M 195.792969 56.3125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface56",
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 26.253906 56.714844 C 26.785156 56.980469 26.785156 56.980469 26.253906 56.714844 Z M 26.253906 56.714844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface59",
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 22.644531 60.320312 C 23.179688 60.589844 23.179688 60.589844 22.644531 60.320312 Z M 22.644531 60.320312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface62",
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 64.730469 61.121094 C 65.265625 61.390625 65.265625 61.390625 64.730469 61.121094 Z M 64.730469 61.121094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface65",
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 42.285156 64.328125 C 42.820312 64.597656 42.820312 64.597656 42.285156 64.328125 Z M 42.285156 64.328125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface68",
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 181.761719 65.53125 C 182.296875 65.796875 182.296875 65.796875 181.761719 65.53125 Z M 181.761719 65.53125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface71",
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 160.921875 66.734375 C 161.457031 67 161.457031 67 160.921875 66.734375 Z M 160.921875 66.734375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface74",
    clipPath: "url(#clip24)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 58.71875 67.132812 C 59.25 67.402344 59.25 67.402344 58.71875 67.132812 Z M 58.71875 67.132812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface77",
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 72.34375 67.535156 C 72.878906 67.800781 72.878906 67.800781 72.34375 67.535156 Z M 72.34375 67.535156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface80",
    clipPath: "url(#clip26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 44.289062 69.941406 C 44.824219 70.207031 44.824219 70.207031 44.289062 69.941406 Z M 44.289062 69.941406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface83",
    clipPath: "url(#clip27)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 12.222656 71.140625 C 12.757812 71.410156 12.757812 71.410156 12.222656 71.140625 Z M 12.222656 71.140625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.105882,
      stroke: "none"
    }
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface86",
    clipPath: "url(#clip28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(25.098039%,25.098039%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 58.316406 74.347656 C 59.242188 74.082031 60.246094 73.949219 61.324219 73.949219 C 63.097656 73.90625 64.765625 74.171875 66.332031 74.75 C 63.671875 74.464844 61 74.332031 58.316406 74.347656 Z M 58.316406 74.347656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface89",
    clipPath: "url(#clip29)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 75.148438 73.949219 C 75.683594 74.214844 75.683594 74.214844 75.148438 73.949219 Z M 75.148438 73.949219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.592157,
      stroke: "none"
    }
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface92",
    clipPath: "url(#clip30)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.45098%,47.45098%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 57.914062 74.347656 C 56.953125 74.855469 55.882812 75.125 54.710938 75.148438 C 55.648438 74.53125 56.714844 74.265625 57.914062 74.347656 Z M 57.914062 74.347656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.470588,
      stroke: "none"
    }
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface95",
    clipPath: "url(#clip31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(38.823529%,38.823529%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 134.871094 74.347656 C 133.90625 74.855469 132.835938 75.125 131.664062 75.148438 C 132.601562 74.53125 133.667969 74.265625 134.871094 74.347656 Z M 134.871094 74.347656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.890196,
      stroke: "none"
    }
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface98",
    clipPath: "url(#clip32)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.058824%,67.058824%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 131.261719 75.148438 C 130.199219 76.34375 128.863281 77.011719 127.253906 77.15625 C 128.351562 76.070312 129.6875 75.402344 131.261719 75.148438 Z M 131.261719 75.148438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface101",
    clipPath: "url(#clip33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(61.568627%,61.568627%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 146.09375 75.550781 C 147.191406 75.632812 148.125 76.035156 148.898438 76.753906 C 148.078125 76.730469 147.210938 76.730469 146.292969 76.753906 C 146.097656 76.375 146.03125 75.972656 146.09375 75.550781 Z M 146.09375 75.550781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.937255,
      stroke: "none"
    }
  }))), _clipPath34 || (_clipPath34 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface104",
    clipPath: "url(#clip34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(56.470588%,56.470588%,56.470588%)",
      fillOpacity: 1
    },
    d: "M 71.140625 76.351562 C 71.917969 76.597656 72.585938 76.996094 73.144531 77.554688 C 72.046875 78.078125 71.378906 77.679688 71.140625 76.351562 Z M 71.140625 76.351562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.529412,
      stroke: "none"
    }
  }))), _clipPath35 || (_clipPath35 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface107",
    clipPath: "url(#clip35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(40.784314%,40.784314%,40.784314%)",
      fillOpacity: 1
    },
    d: "M 49.898438 77.15625 C 49.710938 77.71875 49.308594 77.984375 48.699219 77.957031 C 48.886719 77.390625 49.289062 77.125 49.898438 77.15625 Z M 49.898438 77.15625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.890196,
      stroke: "none"
    }
  }))), _clipPath36 || (_clipPath36 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface110",
    clipPath: "url(#clip36)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(60.392157%,60.392157%,60.392157%)",
      fillOpacity: 1
    },
    d: "M 149.296875 76.753906 C 150.996094 77.53125 152.464844 78.601562 153.707031 79.960938 C 153.167969 79.691406 152.699219 79.691406 152.304688 79.960938 C 151.902344 79.425781 151.503906 78.890625 151.101562 78.355469 C 150.703125 78.355469 150.300781 78.355469 149.898438 78.355469 C 149.582031 77.859375 149.382812 77.324219 149.296875 76.753906 Z M 149.296875 76.753906 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath37 || (_clipPath37 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface113",
    clipPath: "url(#clip37)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 117.234375 79.558594 C 117.769531 79.828125 117.769531 79.828125 117.234375 79.558594 Z M 117.234375 79.558594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.690196,
      stroke: "none"
    }
  }))), _clipPath38 || (_clipPath38 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface116",
    clipPath: "url(#clip38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(54.117647%,54.117647%,54.117647%)",
      fillOpacity: 1
    },
    d: "M 125.25 78.355469 C 124.683594 79.324219 123.882812 79.992188 122.84375 80.359375 C 123.410156 79.394531 124.210938 78.726562 125.25 78.355469 Z M 125.25 78.355469 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.466667,
      stroke: "none"
    }
  }))), _clipPath39 || (_clipPath39 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface119",
    clipPath: "url(#clip39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(41.568627%,41.568627%,41.568627%)",
      fillOpacity: 1
    },
    d: "M 47.09375 79.160156 C 46.660156 79.996094 45.992188 80.527344 45.089844 80.761719 C 45.523438 79.925781 46.191406 79.390625 47.09375 79.160156 Z M 47.09375 79.160156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath40 || (_clipPath40 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface122",
    clipPath: "url(#clip40)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 178.957031 80.359375 C 179.492188 80.628906 179.492188 80.628906 178.957031 80.359375 Z M 178.957031 80.359375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.901961,
      stroke: "none"
    }
  }))), _clipPath41 || (_clipPath41 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface125",
    clipPath: "url(#clip41)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(59.215686%,59.215686%,59.215686%)",
      fillOpacity: 1
    },
    d: "M 82.765625 80.761719 C 85.804688 80.636719 88.8125 80.769531 91.785156 81.164062 C 92.113281 91.601562 92.046875 102.019531 91.582031 112.425781 C 90.113281 112.558594 88.644531 112.691406 87.175781 112.824219 C 85.53125 112.808594 83.996094 112.542969 82.566406 112.023438 C 82.238281 101.585938 82.304688 91.164062 82.765625 80.761719 Z M 82.765625 80.761719 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath42 || (_clipPath42 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface128",
    clipPath: "url(#clip42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.588235%,90.588235%,90.588235%)",
      fillOpacity: 1
    },
    d: "M 100 81.164062 C 100.535156 91.582031 100.535156 102.003906 100 112.425781 C 98.398438 112.425781 96.792969 112.425781 95.191406 112.425781 C 95.191406 102.003906 95.191406 91.582031 95.191406 81.164062 C 96.792969 81.164062 98.398438 81.164062 100 81.164062 Z M 100 81.164062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.341176,
      stroke: "none"
    }
  }))), _clipPath43 || (_clipPath43 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface131",
    clipPath: "url(#clip43)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.509804%,34.509804%,34.509804%)",
      fillOpacity: 1
    },
    d: "M 45.089844 80.761719 C 44.859375 81.664062 44.324219 82.332031 43.488281 82.765625 C 43.71875 81.863281 44.253906 81.195312 45.089844 80.761719 Z M 45.089844 80.761719 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.341176,
      stroke: "none"
    }
  }))), _clipPath44 || (_clipPath44 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface134",
    clipPath: "url(#clip44)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.333333%,33.333333%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 155.3125 81.5625 C 155.875 81.753906 156.140625 82.152344 156.113281 82.765625 C 155.546875 82.574219 155.28125 82.175781 155.3125 81.5625 Z M 155.3125 81.5625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.341176,
      stroke: "none"
    }
  }))), _clipPath45 || (_clipPath45 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface137",
    clipPath: "url(#clip45)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(49.411765%,49.411765%,49.411765%)",
      fillOpacity: 1
    },
    d: "M 100 81.164062 C 98.398438 81.164062 96.792969 81.164062 95.191406 81.164062 C 95.191406 91.582031 95.191406 102.003906 95.191406 112.425781 C 96.792969 112.425781 98.398438 112.425781 100 112.425781 C 98.34375 112.820312 96.605469 112.953125 94.789062 112.824219 C 94.789062 102.136719 94.789062 91.449219 94.789062 80.761719 C 96.605469 80.632812 98.34375 80.765625 100 81.164062 Z M 100 81.164062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.694118,
      stroke: "none"
    }
  }))), _clipPath46 || (_clipPath46 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface140",
    clipPath: "url(#clip46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.372549%,51.372549%,51.372549%)",
      fillOpacity: 1
    },
    d: "M 122.445312 80.761719 C 122.015625 81.136719 121.484375 81.269531 120.839844 81.164062 C 120.839844 91.582031 120.839844 102.003906 120.839844 112.425781 C 121.96875 112.234375 122.769531 112.636719 123.246094 113.628906 C 122.160156 113.238281 121.160156 112.707031 120.242188 112.023438 C 119.972656 101.871094 119.972656 91.714844 120.242188 81.5625 C 120.800781 80.886719 121.535156 80.617188 122.445312 80.761719 Z M 122.445312 80.761719 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.917647,
      stroke: "none"
    }
  }))), _clipPath47 || (_clipPath47 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface143",
    clipPath: "url(#clip47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(64.705882%,64.705882%,64.705882%)",
      fillOpacity: 1
    },
    d: "M 156.113281 82.765625 C 157.074219 83.484375 157.742188 84.421875 158.117188 85.570312 C 157.5625 85.050781 156.894531 84.714844 156.113281 84.570312 C 156.476562 84.003906 156.476562 83.402344 156.113281 82.765625 Z M 156.113281 82.765625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath48 || (_clipPath48 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface146",
    clipPath: "url(#clip48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 161.722656 84.769531 C 162.257812 85.035156 162.257812 85.035156 161.722656 84.769531 Z M 161.722656 84.769531 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.929412,
      stroke: "none"
    }
  }))), _clipPath49 || (_clipPath49 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface149",
    clipPath: "url(#clip49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.431373%,58.431373%,58.431373%)",
      fillOpacity: 1
    },
    d: "M 42.285156 84.367188 C 41.917969 85.003906 41.917969 85.605469 42.285156 86.171875 C 41.90625 86.367188 41.503906 86.433594 41.082031 86.371094 C 41.183594 85.5 41.582031 84.832031 42.285156 84.367188 Z M 42.285156 84.367188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.894118,
      stroke: "none"
    }
  }))), _clipPath50 || (_clipPath50 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface152",
    clipPath: "url(#clip50)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(78.823529%,78.823529%,78.823529%)",
      fillOpacity: 1
    },
    d: "M 158.117188 85.570312 C 159.46875 87.613281 160.269531 89.886719 160.519531 92.386719 C 159.867188 92.253906 159.464844 91.855469 159.320312 91.183594 C 159.132812 89.960938 158.730469 88.824219 158.117188 87.777344 C 158.570312 87.367188 158.4375 87.101562 157.714844 86.972656 C 158.050781 86.570312 158.183594 86.101562 158.117188 85.570312 Z M 158.117188 85.570312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.172549,
      stroke: "none"
    }
  }))), _clipPath51 || (_clipPath51 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface155",
    clipPath: "url(#clip51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.333333%,33.333333%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 39.078125 91.984375 C 39.195312 92.878906 39.0625 93.679688 38.675781 94.390625 C 38.5 94.414062 38.367188 94.347656 38.277344 94.1875 C 38.519531 93.40625 38.789062 92.671875 39.078125 91.984375 Z M 39.078125 91.984375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.160784,
      stroke: "none"
    }
  }))), _clipPath52 || (_clipPath52 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface158",
    clipPath: "url(#clip52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.941176%,32.941176%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 160.921875 94.390625 C 164.570312 94.644531 168.175781 94.914062 171.742188 95.191406 C 167.976562 95.445312 164.371094 95.179688 160.921875 94.390625 Z M 160.921875 94.390625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.129412,
      stroke: "none"
    }
  }))), _clipPath53 || (_clipPath53 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface161",
    clipPath: "url(#clip53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(29.019608%,29.019608%,29.019608%)",
      fillOpacity: 1
    },
    d: "M 108.417969 81.164062 C 106.8125 81.164062 105.210938 81.164062 103.605469 81.164062 C 103.605469 91.582031 103.605469 102.003906 103.605469 112.425781 C 103.335938 108.121094 103.070312 103.78125 102.804688 99.398438 C 103.203125 93.21875 103.335938 87.003906 103.207031 80.761719 C 105.023438 80.632812 106.761719 80.765625 108.417969 81.164062 Z M 108.417969 81.164062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath54 || (_clipPath54 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface164",
    clipPath: "url(#clip54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(73.333333%,73.333333%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 174.949219 95.992188 C 176.777344 96.570312 178.246094 97.640625 179.359375 99.199219 C 179.113281 99.242188 178.910156 99.375 178.757812 99.597656 C 177.558594 98.800781 176.492188 97.867188 175.550781 96.792969 C 175.417969 96.925781 175.285156 97.0625 175.148438 97.195312 C 174.957031 96.8125 174.890625 96.414062 174.949219 95.992188 Z M 174.949219 95.992188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.309804,
      stroke: "none"
    }
  }))), _clipPath55 || (_clipPath55 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface167",
    clipPath: "url(#clip55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(54.509804%,54.509804%,54.509804%)",
      fillOpacity: 1
    },
    d: "M 27.855469 98.398438 C 31.390625 98 34.996094 97.863281 38.675781 97.996094 C 38.675781 98.398438 38.675781 98.796875 38.675781 99.199219 C 35.578125 98.429688 32.375 98.164062 29.058594 98.398438 C 28.65625 98.398438 28.257812 98.398438 27.855469 98.398438 Z M 27.855469 98.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask55"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.278431,
      stroke: "none"
    }
  }))), _clipPath56 || (_clipPath56 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface170",
    clipPath: "url(#clip56)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(53.333333%,53.333333%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 172.945312 98.796875 C 168.84375 98.164062 164.835938 98.296875 160.921875 99.199219 C 160.921875 98.796875 160.921875 98.398438 160.921875 97.996094 C 164.398438 97.929688 167.871094 97.996094 171.34375 98.195312 C 171.96875 98.28125 172.5 98.480469 172.945312 98.796875 Z M 172.945312 98.796875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0666667,
      stroke: "none"
    }
  }))), _clipPath57 || (_clipPath57 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface173",
    clipPath: "url(#clip57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20.784314%,20.784314%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 27.855469 98.398438 C 28.257812 98.398438 28.65625 98.398438 29.058594 98.398438 C 28.070312 98.808594 27.003906 99.078125 25.851562 99.199219 C 26.363281 98.625 27.03125 98.359375 27.855469 98.398438 Z M 27.855469 98.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask57"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath58 || (_clipPath58 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface176",
    clipPath: "url(#clip58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(71.372549%,71.372549%,71.372549%)",
      fillOpacity: 1
    },
    d: "M 25.050781 99.597656 C 24.125 100.390625 23.191406 101.191406 22.246094 102.003906 C 22.277344 101.605469 22.144531 101.269531 21.84375 101.003906 C 22.59375 99.621094 23.664062 99.152344 25.050781 99.597656 Z M 25.050781 99.597656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath59 || (_clipPath59 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface179",
    clipPath: "url(#clip59)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(78.039216%,78.039216%,78.039216%)",
      fillOpacity: 1
    },
    d: "M 177.753906 102.40625 C 176.371094 100.882812 174.765625 99.679688 172.945312 98.796875 C 173.207031 98.5625 173.472656 98.292969 173.746094 97.996094 C 175.945312 98.722656 177.28125 100.191406 177.753906 102.40625 Z M 177.753906 102.40625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask59"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.168627,
      stroke: "none"
    }
  }))), _clipPath60 || (_clipPath60 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface182",
    clipPath: "url(#clip60)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(29.411765%,29.411765%,29.411765%)",
      fillOpacity: 1
    },
    d: "M 19.4375 100 C 19.46875 100.613281 19.199219 101.011719 18.636719 101.203125 C 18.609375 100.589844 18.875 100.191406 19.4375 100 Z M 19.4375 100 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.156863,
      stroke: "none"
    }
  }))), _clipPath61 || (_clipPath61 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface185",
    clipPath: "url(#clip61)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(37.254902%,37.254902%,37.254902%)",
      fillOpacity: 1
    },
    d: "M 116.832031 81.164062 C 117.234375 91.648438 117.367188 102.203125 117.234375 112.824219 C 115.417969 112.953125 113.679688 112.820312 112.023438 112.425781 C 113.628906 112.425781 115.230469 112.425781 116.832031 112.425781 C 116.832031 102.003906 116.832031 91.582031 116.832031 81.164062 Z M 116.832031 81.164062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask61"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.172549,
      stroke: "none"
    }
  }))), _clipPath62 || (_clipPath62 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface188",
    clipPath: "url(#clip62)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.333333%,33.333333%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 180.160156 100 C 180.722656 100.191406 180.992188 100.589844 180.960938 101.203125 C 180.398438 101.011719 180.132812 100.613281 180.160156 100 Z M 180.160156 100 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask62"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.807843,
      stroke: "none"
    }
  }))), _clipPath63 || (_clipPath63 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface191",
    clipPath: "url(#clip63)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.764706%,51.764706%,51.764706%)",
      fillOpacity: 1
    },
    d: "M 180.960938 101.203125 C 182.074219 102.417969 182.609375 103.753906 182.566406 105.210938 C 182.125 104.5 181.789062 103.695312 181.5625 102.804688 C 181.261719 102.554688 180.929688 102.355469 180.5625 102.203125 C 180.863281 101.933594 180.996094 101.601562 180.960938 101.203125 Z M 180.960938 101.203125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask63"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath64 || (_clipPath64 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface194",
    clipPath: "url(#clip64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.843137%,67.843137%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 39.480469 103.207031 C 40.515625 103.425781 40.785156 103.960938 40.28125 104.808594 C 41.476562 105.328125 41.746094 106.128906 41.082031 107.214844 C 40.164062 106.0625 39.628906 104.726562 39.480469 103.207031 Z M 39.480469 103.207031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask64"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.933333,
      stroke: "none"
    }
  }))), _clipPath65 || (_clipPath65 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface197",
    clipPath: "url(#clip65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(71.372549%,71.372549%,71.372549%)",
      fillOpacity: 1
    },
    d: "M 159.320312 105.609375 C 158.988281 106.808594 158.453125 107.875 157.714844 108.816406 C 157.699219 108.382812 157.566406 107.984375 157.316406 107.613281 C 157.582031 107.480469 157.847656 107.347656 158.117188 107.214844 C 157.546875 106.039062 157.949219 105.507812 159.320312 105.609375 Z M 159.320312 105.609375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask65"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.627451,
      stroke: "none"
    }
  }))), _clipPath66 || (_clipPath66 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface200",
    clipPath: "url(#clip66)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(57.647059%,57.647059%,57.647059%)",
      fillOpacity: 1
    },
    d: "M 17.835938 102.804688 C 17.886719 103.667969 17.6875 104.472656 17.234375 105.210938 C 17.035156 118.972656 16.96875 132.730469 17.035156 146.492188 C 17.835938 146.492188 18.636719 146.492188 19.4375 146.492188 C 19.304688 133.464844 19.441406 120.503906 19.839844 107.613281 C 19.839844 120.707031 19.839844 133.800781 19.839844 146.894531 C 18.824219 147.175781 17.820312 147.3125 16.832031 147.292969 C 16.632812 146.894531 16.433594 146.492188 16.234375 146.09375 C 16.183594 133.695312 16.25 121.269531 16.433594 108.816406 C 16.566406 107.480469 16.699219 106.144531 16.832031 104.808594 C 16.984375 104.011719 17.316406 103.34375 17.835938 102.804688 Z M 17.835938 102.804688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask66"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.960784,
      stroke: "none"
    }
  }))), _clipPath67 || (_clipPath67 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface203",
    clipPath: "url(#clip67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.45098%,67.45098%,67.45098%)",
      fillOpacity: 1
    },
    d: "M 41.082031 107.613281 C 41.792969 107.984375 42.457031 108.453125 43.085938 109.019531 C 42.953125 109.152344 42.820312 109.285156 42.683594 109.417969 C 43.277344 109.703125 43.542969 110.171875 43.488281 110.820312 C 42.496094 109.910156 41.695312 108.84375 41.082031 107.613281 Z M 41.082031 107.613281 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask67"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.686275,
      stroke: "none"
    }
  }))), _clipPath68 || (_clipPath68 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip68"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface206",
    clipPath: "url(#clip68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(59.215686%,59.215686%,59.215686%)",
      fillOpacity: 1
    },
    d: "M 182.566406 105.609375 C 182.882812 106.054688 183.082031 106.589844 183.167969 107.214844 C 183.433594 120.441406 183.433594 133.667969 183.167969 146.894531 C 183.03125 147.027344 182.898438 147.160156 182.765625 147.292969 C 181.585938 147.15625 180.585938 146.753906 179.757812 146.09375 C 179.757812 133.265625 179.757812 120.441406 179.757812 107.613281 C 180.160156 120.503906 180.292969 133.464844 180.160156 146.492188 C 180.960938 146.492188 181.761719 146.492188 182.566406 146.492188 C 182.566406 132.867188 182.566406 119.238281 182.566406 105.609375 Z M 182.566406 105.609375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask68"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.92549,
      stroke: "none"
    }
  }))), _clipPath69 || (_clipPath69 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface209",
    clipPath: "url(#clip69)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.058824%,67.058824%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 157.714844 108.816406 C 157.03125 110.449219 155.960938 111.785156 154.507812 112.824219 C 153.914062 111.675781 154.3125 111.140625 155.710938 111.222656 C 155.519531 109.679688 156.1875 108.878906 157.714844 108.816406 Z M 157.714844 108.816406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask69"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath70 || (_clipPath70 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip70"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface212",
    clipPath: "url(#clip70)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 161.324219 110.421875 C 161.855469 110.6875 161.855469 110.6875 161.324219 110.421875 Z M 161.324219 110.421875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask70"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath71 || (_clipPath71 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface215",
    clipPath: "url(#clip71)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(15.686275%,15.686275%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 20.640625 104.808594 C 20.382812 118.894531 20.113281 132.921875 19.839844 146.894531 C 19.839844 133.800781 19.839844 120.707031 19.839844 107.613281 C 19.707031 106.523438 19.976562 105.585938 20.640625 104.808594 Z M 20.640625 104.808594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask71"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.917647,
      stroke: "none"
    }
  }))), _clipPath72 || (_clipPath72 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip72"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface218",
    clipPath: "url(#clip72)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(70.980392%,70.980392%,70.980392%)",
      fillOpacity: 1
    },
    d: "M 77.15625 113.226562 C 76.363281 113.882812 75.5625 114.550781 74.75 115.230469 C 74.574219 113.464844 75.375 112.796875 77.15625 113.226562 Z M 77.15625 113.226562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask72"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath73 || (_clipPath73 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface221",
    clipPath: "url(#clip73)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 12.222656 113.628906 C 12.757812 113.894531 12.757812 113.894531 12.222656 113.628906 Z M 12.222656 113.628906 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask73"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.847059,
      stroke: "none"
    }
  }))), _clipPath74 || (_clipPath74 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip74"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface224",
    clipPath: "url(#clip74)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(77.254902%,77.254902%,77.254902%)",
      fillOpacity: 1
    },
    d: "M 51.503906 117.234375 C 49.625 116.496094 47.886719 115.492188 46.292969 114.226562 C 45.113281 113.253906 44.175781 112.117188 43.488281 110.820312 C 43.734375 110.777344 43.933594 110.644531 44.089844 110.421875 C 45.144531 111.207031 45.878906 112.207031 46.292969 113.425781 C 48.472656 114.164062 50.210938 115.433594 51.503906 117.234375 Z M 51.503906 117.234375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask74"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.870588,
      stroke: "none"
    }
  }))), _clipPath75 || (_clipPath75 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip75"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface227",
    clipPath: "url(#clip75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(69.803922%,69.803922%,69.803922%)",
      fillOpacity: 1
    },
    d: "M 153.707031 113.628906 C 153.070312 114.480469 152.269531 115.148438 151.300781 115.632812 C 151.394531 113.90625 152.195312 113.238281 153.707031 113.628906 Z M 153.707031 113.628906 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask75"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath76 || (_clipPath76 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip76"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface230",
    clipPath: "url(#clip76)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 165.730469 114.828125 C 166.265625 115.097656 166.265625 115.097656 165.730469 114.828125 Z M 165.730469 114.828125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask76"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.917647,
      stroke: "none"
    }
  }))), _clipPath77 || (_clipPath77 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip77"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface233",
    clipPath: "url(#clip77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(75.294118%,75.294118%,75.294118%)",
      fillOpacity: 1
    },
    d: "M 134.871094 119.238281 C 131.199219 118.910156 127.992188 117.574219 125.25 115.230469 C 125.910156 115.316406 126.511719 115.183594 127.054688 114.828125 C 127.664062 116.0625 128.667969 116.796875 130.058594 117.035156 C 129.722656 117.703125 129.925781 117.769531 130.660156 117.234375 C 130.792969 117.5 130.929688 117.769531 131.0625 118.035156 C 131.753906 117.605469 132.488281 117.539062 133.265625 117.835938 C 133.371094 118.535156 133.90625 119 134.871094 119.238281 Z M 134.871094 119.238281 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask77"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.14902,
      stroke: "none"
    }
  }))), _clipPath78 || (_clipPath78 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip78"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface236",
    clipPath: "url(#clip78)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.333333%,33.333333%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 143.6875 118.835938 C 142.058594 119.445312 140.324219 119.714844 138.476562 119.640625 C 137.199219 119.636719 135.996094 119.503906 134.871094 119.238281 C 137.820312 119.292969 140.761719 119.160156 143.6875 118.835938 Z M 143.6875 118.835938 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask78"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath79 || (_clipPath79 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface239",
    clipPath: "url(#clip79)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 31.464844 120.441406 C 31.996094 120.707031 31.996094 120.707031 31.464844 120.441406 Z M 31.464844 120.441406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask79"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath80 || (_clipPath80 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip80"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface242",
    clipPath: "url(#clip80)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 110.820312 122.042969 C 111.355469 122.3125 111.355469 122.3125 110.820312 122.042969 Z M 110.820312 122.042969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask80"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath81 || (_clipPath81 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip81"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface245",
    clipPath: "url(#clip81)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 140.480469 122.84375 C 141.015625 123.113281 141.015625 123.113281 140.480469 122.84375 Z M 140.480469 122.84375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask81"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.027451,
      stroke: "none"
    }
  }))), _clipPath82 || (_clipPath82 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip82"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface248",
    clipPath: "url(#clip82)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(11.764706%,11.764706%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 178.957031 104.808594 C 179.625 105.585938 179.890625 106.523438 179.757812 107.613281 C 179.757812 120.441406 179.757812 133.265625 179.757812 146.09375 C 179.484375 132.386719 179.21875 118.625 178.957031 104.808594 Z M 178.957031 104.808594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask82"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath83 || (_clipPath83 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip83"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface251",
    clipPath: "url(#clip83)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 99.199219 125.652344 C 99.734375 125.917969 99.734375 125.917969 99.199219 125.652344 Z M 99.199219 125.652344 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask83"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath84 || (_clipPath84 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip84"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface254",
    clipPath: "url(#clip84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 166.933594 128.457031 C 167.46875 128.722656 167.46875 128.722656 166.933594 128.457031 Z M 166.933594 128.457031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask84"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath85 || (_clipPath85 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip85"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface257",
    clipPath: "url(#clip85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 84.769531 128.859375 C 85.304688 129.125 85.304688 129.125 84.769531 128.859375 Z M 84.769531 128.859375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask85"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath86 || (_clipPath86 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface260",
    clipPath: "url(#clip86)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 71.945312 129.660156 C 72.476562 129.925781 72.476562 129.925781 71.945312 129.660156 Z M 71.945312 129.660156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask86"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath87 || (_clipPath87 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip87"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface263",
    clipPath: "url(#clip87)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.417969 131.664062 C 9.953125 131.929688 9.953125 131.929688 9.417969 131.664062 Z M 9.417969 131.664062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask87"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath88 || (_clipPath88 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip88"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface266",
    clipPath: "url(#clip88)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 41.484375 131.664062 C 42.015625 131.929688 42.015625 131.929688 41.484375 131.664062 Z M 41.484375 131.664062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask88"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath89 || (_clipPath89 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip89"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface269",
    clipPath: "url(#clip89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.042969 132.0625 C 21.578125 132.332031 21.578125 132.332031 21.042969 132.0625 Z M 21.042969 132.0625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask89"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath90 || (_clipPath90 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip90"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface272",
    clipPath: "url(#clip90)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 8.214844 134.46875 C 8.75 134.734375 8.75 134.734375 8.214844 134.46875 Z M 8.214844 134.46875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask90"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath91 || (_clipPath91 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip91"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface275",
    clipPath: "url(#clip91)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 117.636719 134.46875 C 118.167969 134.734375 118.167969 134.734375 117.636719 134.46875 Z M 117.636719 134.46875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask91"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath92 || (_clipPath92 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip92"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface278",
    clipPath: "url(#clip92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 169.738281 136.875 C 170.273438 137.140625 170.273438 137.140625 169.738281 136.875 Z M 169.738281 136.875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask92"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath93 || (_clipPath93 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip93"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface281",
    clipPath: "url(#clip93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 14.628906 138.074219 C 15.164062 138.34375 15.164062 138.34375 14.628906 138.074219 Z M 14.628906 138.074219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask93"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath94 || (_clipPath94 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface284",
    clipPath: "url(#clip94)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.445312 142.085938 C 23.980469 142.351562 23.980469 142.351562 23.445312 142.085938 Z M 23.445312 142.085938 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask94"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath95 || (_clipPath95 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip95"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface287",
    clipPath: "url(#clip95)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 72.34375 143.285156 C 72.878906 143.554688 72.878906 143.554688 72.34375 143.285156 Z M 72.34375 143.285156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask95"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath96 || (_clipPath96 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip96"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface290",
    clipPath: "url(#clip96)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 92.386719 144.089844 C 92.917969 144.355469 92.917969 144.355469 92.386719 144.089844 Z M 92.386719 144.089844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask96"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath97 || (_clipPath97 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip97"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface293",
    clipPath: "url(#clip97)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 143.285156 145.691406 C 143.820312 145.957031 143.820312 145.957031 143.285156 145.691406 Z M 143.285156 145.691406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask97"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath98 || (_clipPath98 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip98"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface296",
    clipPath: "url(#clip98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 90.78125 149.699219 C 91.316406 149.964844 91.316406 149.964844 90.78125 149.699219 Z M 90.78125 149.699219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask98"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath99 || (_clipPath99 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip99"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface299",
    clipPath: "url(#clip99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 19.839844 150.902344 C 20.375 151.167969 20.375 151.167969 19.839844 150.902344 Z M 19.839844 150.902344 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask99"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath100 || (_clipPath100 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip100"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface302",
    clipPath: "url(#clip100)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 59.519531 157.316406 C 60.054688 157.582031 60.054688 157.582031 59.519531 157.316406 Z M 59.519531 157.316406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask100"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath101 || (_clipPath101 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip101"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface305",
    clipPath: "url(#clip101)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 116.03125 159.71875 C 116.566406 159.988281 116.566406 159.988281 116.03125 159.71875 Z M 116.03125 159.71875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask101"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath102 || (_clipPath102 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface308",
    clipPath: "url(#clip102)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 126.453125 162.125 C 126.988281 162.390625 126.988281 162.390625 126.453125 162.125 Z M 126.453125 162.125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask102"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath103 || (_clipPath103 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip103"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface311",
    clipPath: "url(#clip103)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 7.015625 164.128906 C 7.546875 164.394531 7.546875 164.394531 7.015625 164.128906 Z M 7.015625 164.128906 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask103"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath104 || (_clipPath104 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip104"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface314",
    clipPath: "url(#clip104)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 34.667969 166.933594 C 35.203125 167.203125 35.203125 167.203125 34.667969 166.933594 Z M 34.667969 166.933594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask104"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath105 || (_clipPath105 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip105"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface317",
    clipPath: "url(#clip105)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.445312 170.140625 C 23.980469 170.40625 23.980469 170.40625 23.445312 170.140625 Z M 23.445312 170.140625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask105"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath106 || (_clipPath106 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip106"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface320",
    clipPath: "url(#clip106)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.257812 174.550781 C 28.789062 174.816406 28.789062 174.816406 28.257812 174.550781 Z M 28.257812 174.550781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask106"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath107 || (_clipPath107 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip107"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface323",
    clipPath: "url(#clip107)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 127.65625 174.949219 C 128.191406 175.21875 128.191406 175.21875 127.65625 174.949219 Z M 127.65625 174.949219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask107"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath108 || (_clipPath108 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip108"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface326",
    clipPath: "url(#clip108)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 57.914062 179.757812 C 58.449219 180.027344 58.449219 180.027344 57.914062 179.757812 Z M 57.914062 179.757812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask108"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath109 || (_clipPath109 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip109"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface329",
    clipPath: "url(#clip109)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 91.183594 181.363281 C 91.714844 181.628906 91.714844 181.628906 91.183594 181.363281 Z M 91.183594 181.363281 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask109"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath110 || (_clipPath110 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip110"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface332",
    clipPath: "url(#clip110)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 67.535156 182.164062 C 68.070312 182.433594 68.070312 182.433594 67.535156 182.164062 Z M 67.535156 182.164062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask110"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath111 || (_clipPath111 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip111"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface335",
    clipPath: "url(#clip111)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 25.851562 182.566406 C 26.386719 182.832031 26.386719 182.832031 25.851562 182.566406 Z M 25.851562 182.566406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask111"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath112 || (_clipPath112 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip112"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface338",
    clipPath: "url(#clip112)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 13.425781 182.964844 C 13.960938 183.234375 13.960938 183.234375 13.425781 182.964844 Z M 13.425781 182.964844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask112"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath113 || (_clipPath113 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip113"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface341",
    clipPath: "url(#clip113)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 109.21875 185.371094 C 109.753906 185.636719 109.753906 185.636719 109.21875 185.371094 Z M 109.21875 185.371094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask113"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath114 || (_clipPath114 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip114"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface344",
    clipPath: "url(#clip114)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 53.105469 189.78125 C 53.640625 190.046875 53.640625 190.046875 53.105469 189.78125 Z M 53.105469 189.78125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask114"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath115 || (_clipPath115 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip115"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface347",
    clipPath: "url(#clip115)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 6.613281 191.382812 C 7.148438 191.648438 7.148438 191.648438 6.613281 191.382812 Z M 6.613281 191.382812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask115"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath116 || (_clipPath116 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip116"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface350",
    clipPath: "url(#clip116)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 69.941406 191.785156 C 70.472656 192.050781 70.472656 192.050781 69.941406 191.785156 Z M 69.941406 191.785156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask116"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath117 || (_clipPath117 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip117"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface353",
    clipPath: "url(#clip117)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 85.570312 191.785156 C 86.105469 192.050781 86.105469 192.050781 85.570312 191.785156 Z M 85.570312 191.785156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask117"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath118 || (_clipPath118 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip118"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface356",
    clipPath: "url(#clip118)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.421875 194.988281 C 11.957031 195.257812 11.957031 195.257812 11.421875 194.988281 Z M 11.421875 194.988281 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask118"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.00392157,
      stroke: "none"
    }
  }))), _clipPath119 || (_clipPath119 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip119"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface359",
    clipPath: "url(#clip119)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 128.054688 197.394531 C 128.589844 197.664062 128.589844 197.664062 128.054688 197.394531 Z M 128.054688 197.394531 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface32",
    mask: "url(#mask9)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask10)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface41",
    mask: "url(#mask12)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface44",
    mask: "url(#mask13)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface47",
    mask: "url(#mask14)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface50",
    mask: "url(#mask15)"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface53",
    mask: "url(#mask16)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface56",
    mask: "url(#mask17)"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface59",
    mask: "url(#mask18)"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface62",
    mask: "url(#mask19)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface65",
    mask: "url(#mask20)"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface68",
    mask: "url(#mask21)"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface71",
    mask: "url(#mask22)"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface74",
    mask: "url(#mask23)"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface77",
    mask: "url(#mask24)"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface80",
    mask: "url(#mask25)"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface83",
    mask: "url(#mask26)"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface86",
    mask: "url(#mask27)"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface89",
    mask: "url(#mask28)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.039216%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 57.914062 74.347656 C 58.050781 74.347656 58.183594 74.347656 58.316406 74.347656 C 61 74.332031 63.671875 74.464844 66.332031 74.75 C 67.394531 74.714844 68.332031 74.980469 69.136719 75.550781 C 69.078125 75.972656 69.144531 76.375 69.339844 76.753906 C 69.882812 76.402344 70.484375 76.265625 71.140625 76.351562 C 71.378906 77.679688 72.046875 78.078125 73.144531 77.554688 C 74.75 78.152344 76.085938 79.152344 77.15625 80.5625 C 77.929688 80.660156 78.664062 80.863281 79.359375 81.164062 C 79.625 91.582031 79.625 102.003906 79.359375 112.425781 C 78.632812 112.722656 77.898438 112.992188 77.15625 113.226562 C 75.375 112.796875 74.574219 113.464844 74.75 115.230469 C 67.351562 120.277344 59.601562 120.945312 51.503906 117.234375 C 50.210938 115.433594 48.472656 114.164062 46.292969 113.425781 C 45.878906 112.207031 45.144531 111.207031 44.089844 110.421875 C 43.933594 110.644531 43.734375 110.777344 43.488281 110.820312 C 43.542969 110.171875 43.277344 109.703125 42.683594 109.417969 C 42.820312 109.285156 42.953125 109.152344 43.085938 109.019531 C 42.457031 108.453125 41.792969 107.984375 41.082031 107.613281 C 41.082031 107.480469 41.082031 107.347656 41.082031 107.214844 C 41.746094 106.128906 41.476562 105.328125 40.28125 104.808594 C 40.785156 103.960938 40.515625 103.425781 39.480469 103.207031 C 38.875 101.988281 38.605469 100.648438 38.675781 99.199219 C 38.675781 98.796875 38.675781 98.398438 38.675781 97.996094 C 34.996094 97.863281 31.390625 98 27.855469 98.398438 C 27.03125 98.359375 26.363281 98.625 25.851562 99.199219 C 25.714844 99.535156 25.449219 99.667969 25.050781 99.597656 C 23.664062 99.152344 22.59375 99.621094 21.84375 101.003906 C 22.144531 101.269531 22.277344 101.605469 22.246094 102.003906 C 21.683594 102.957031 21.148438 103.890625 20.640625 104.808594 C 19.976562 105.585938 19.707031 106.523438 19.839844 107.613281 C 19.441406 120.503906 19.304688 133.464844 19.4375 146.492188 C 18.636719 146.492188 17.835938 146.492188 17.035156 146.492188 C 16.96875 132.730469 17.035156 118.972656 17.234375 105.210938 C 17.6875 104.472656 17.886719 103.667969 17.835938 102.804688 C 18.320312 102.511719 18.855469 102.378906 19.4375 102.40625 C 19.558594 101.144531 20.226562 100.277344 21.441406 99.800781 C 21.128906 99.371094 21.195312 98.902344 21.644531 98.398438 C 23.410156 97.816406 24.945312 96.878906 26.253906 95.589844 C 26.558594 95.285156 26.957031 95.082031 27.453125 94.988281 C 31.265625 94.921875 35.007812 94.722656 38.675781 94.390625 C 39.0625 93.679688 39.195312 92.878906 39.078125 91.984375 C 39.277344 89.914062 39.945312 88.042969 41.082031 86.371094 C 41.503906 86.433594 41.90625 86.367188 42.285156 86.171875 C 41.917969 85.605469 41.917969 85.003906 42.285156 84.367188 C 42.378906 83.605469 42.78125 83.070312 43.488281 82.765625 C 44.324219 82.332031 44.859375 81.664062 45.089844 80.761719 C 45.992188 80.527344 46.660156 79.996094 47.09375 79.160156 C 47.398438 78.453125 47.933594 78.050781 48.699219 77.957031 C 49.308594 77.984375 49.710938 77.71875 49.898438 77.15625 C 51.296875 76.058594 52.898438 75.390625 54.710938 75.148438 C 55.882812 75.125 56.953125 74.855469 57.914062 74.347656 Z M 57.914062 74.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.823529%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 146.09375 75.550781 C 146.03125 75.972656 146.097656 76.375 146.292969 76.753906 C 147.210938 76.730469 148.078125 76.730469 148.898438 76.753906 C 149.03125 76.753906 149.164062 76.753906 149.296875 76.753906 C 149.382812 77.324219 149.582031 77.859375 149.898438 78.355469 C 150.300781 78.355469 150.703125 78.355469 151.101562 78.355469 C 151.503906 78.890625 151.902344 79.425781 152.304688 79.960938 C 152.699219 79.691406 153.167969 79.691406 153.707031 79.960938 C 154.375 80.359375 154.910156 80.894531 155.3125 81.5625 C 155.28125 82.175781 155.546875 82.574219 156.113281 82.765625 C 156.476562 83.402344 156.476562 84.003906 156.113281 84.570312 C 156.894531 84.714844 157.5625 85.050781 158.117188 85.570312 C 158.183594 86.101562 158.050781 86.570312 157.714844 86.972656 C 158.4375 87.101562 158.570312 87.367188 158.117188 87.777344 C 158.730469 88.824219 159.132812 89.960938 159.320312 91.183594 C 159.464844 91.855469 159.867188 92.253906 160.519531 92.386719 C 160.902344 92.953125 161.035156 93.621094 160.921875 94.390625 C 164.371094 95.179688 167.976562 95.445312 171.742188 95.191406 C 172.917969 95.214844 173.984375 95.484375 174.949219 95.992188 C 174.890625 96.414062 174.957031 96.8125 175.148438 97.195312 C 175.285156 97.0625 175.417969 96.925781 175.550781 96.792969 C 176.492188 97.867188 177.558594 98.800781 178.757812 99.597656 C 178.910156 99.375 179.113281 99.242188 179.359375 99.199219 C 179.757812 99.332031 180.027344 99.597656 180.160156 100 C 180.132812 100.613281 180.398438 101.011719 180.960938 101.203125 C 180.996094 101.601562 180.863281 101.933594 180.5625 102.203125 C 180.929688 102.355469 181.261719 102.554688 181.5625 102.804688 C 181.789062 103.695312 182.125 104.5 182.566406 105.210938 C 182.566406 105.34375 182.566406 105.476562 182.566406 105.609375 C 182.566406 119.238281 182.566406 132.867188 182.566406 146.492188 C 181.761719 146.492188 180.960938 146.492188 180.160156 146.492188 C 180.292969 133.464844 180.160156 120.503906 179.757812 107.613281 C 179.890625 106.523438 179.625 105.585938 178.957031 104.808594 C 178.351562 104.136719 177.953125 103.335938 177.753906 102.40625 C 177.28125 100.191406 175.945312 98.722656 173.746094 97.996094 C 173.472656 98.292969 173.207031 98.5625 172.945312 98.796875 C 172.5 98.480469 171.96875 98.28125 171.34375 98.195312 C 167.871094 97.996094 164.398438 97.929688 160.921875 97.996094 C 160.921875 98.398438 160.921875 98.796875 160.921875 99.199219 C 160.878906 101.5 160.347656 103.636719 159.320312 105.609375 C 157.949219 105.507812 157.546875 106.039062 158.117188 107.214844 C 157.847656 107.347656 157.582031 107.480469 157.316406 107.613281 C 157.566406 107.984375 157.699219 108.382812 157.714844 108.816406 C 156.1875 108.878906 155.519531 109.679688 155.710938 111.222656 C 154.3125 111.140625 153.914062 111.675781 154.507812 112.824219 C 154.375 113.226562 154.109375 113.492188 153.707031 113.628906 C 152.195312 113.238281 151.394531 113.90625 151.300781 115.632812 C 149.011719 117.242188 146.472656 118.3125 143.6875 118.835938 C 140.761719 119.160156 137.820312 119.292969 134.871094 119.238281 C 133.90625 119 133.371094 118.535156 133.265625 117.835938 C 132.488281 117.539062 131.753906 117.605469 131.0625 118.035156 C 130.929688 117.769531 130.792969 117.5 130.660156 117.234375 C 129.925781 117.769531 129.722656 117.703125 130.058594 117.035156 C 128.667969 116.796875 127.664062 116.0625 127.054688 114.828125 C 126.511719 115.183594 125.910156 115.316406 125.25 115.230469 C 124.347656 114.996094 123.679688 114.464844 123.246094 113.628906 C 122.769531 112.636719 121.96875 112.234375 120.839844 112.425781 C 120.839844 102.003906 120.839844 91.582031 120.839844 81.164062 C 121.484375 81.269531 122.015625 81.136719 122.445312 80.761719 C 122.445312 80.496094 122.578125 80.359375 122.84375 80.359375 C 123.882812 79.992188 124.683594 79.324219 125.25 78.355469 C 125.714844 77.65625 126.382812 77.253906 127.253906 77.15625 C 128.863281 77.011719 130.199219 76.34375 131.261719 75.148438 C 131.394531 75.148438 131.53125 75.148438 131.664062 75.148438 C 132.835938 75.125 133.90625 74.855469 134.871094 74.347656 C 138.761719 73.617188 142.503906 74.019531 146.09375 75.550781 Z M 146.09375 75.550781 "
  }), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface92",
    mask: "url(#mask29)"
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface95",
    mask: "url(#mask30)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.823529%,58.823529%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 69.136719 75.550781 C 69.902344 75.667969 70.570312 75.9375 71.140625 76.351562 C 70.484375 76.265625 69.882812 76.402344 69.339844 76.753906 C 69.144531 76.375 69.078125 75.972656 69.136719 75.550781 Z M 69.136719 75.550781 "
  }), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface98",
    mask: "url(#mask31)"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface101",
    mask: "url(#mask32)"
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface104",
    mask: "url(#mask33)"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface107",
    mask: "url(#mask34)"
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface110",
    mask: "url(#mask35)"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface113",
    mask: "url(#mask36)"
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface116",
    mask: "url(#mask37)"
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface119",
    mask: "url(#mask38)"
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface122",
    mask: "url(#mask39)"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface125",
    mask: "url(#mask40)"
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface128",
    mask: "url(#mask41)"
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface131",
    mask: "url(#mask42)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 83.566406 81.964844 C 86.074219 81.839844 88.546875 81.972656 90.980469 82.363281 C 91.183594 92.382812 91.25 102.402344 91.183594 112.425781 C 88.507812 112.492188 85.835938 112.425781 83.167969 112.222656 C 83.566406 102.167969 83.699219 92.082031 83.566406 81.964844 Z M 83.566406 81.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(91.372549%,91.372549%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 108.417969 81.164062 C 108.882812 91.515625 108.949219 101.9375 108.617188 112.425781 C 106.90625 112.953125 105.238281 112.953125 103.605469 112.425781 C 103.605469 102.003906 103.605469 91.582031 103.605469 81.164062 C 105.210938 81.164062 106.8125 81.164062 108.417969 81.164062 Z M 108.417969 81.164062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.980392%,90.980392%,90.980392%)",
      fillOpacity: 1
    },
    d: "M 116.832031 81.164062 C 116.832031 91.582031 116.832031 102.003906 116.832031 112.425781 C 115.230469 112.425781 113.628906 112.425781 112.023438 112.425781 C 111.558594 102.070312 111.492188 91.652344 111.824219 81.164062 C 113.535156 80.632812 115.203125 80.632812 116.832031 81.164062 Z M 116.832031 81.164062 "
  }), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface134",
    mask: "url(#mask43)"
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface137",
    mask: "url(#mask44)"
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface140",
    mask: "url(#mask45)"
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface143",
    mask: "url(#mask46)"
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface146",
    mask: "url(#mask47)"
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface149",
    mask: "url(#mask48)"
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface152",
    mask: "url(#mask49)"
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface155",
    mask: "url(#mask50)"
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface158",
    mask: "url(#mask51)"
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface161",
    mask: "url(#mask52)"
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface164",
    mask: "url(#mask53)"
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface167",
    mask: "url(#mask54)"
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface170",
    mask: "url(#mask55)"
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface173",
    mask: "url(#mask56)"
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface176",
    mask: "url(#mask57)"
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface179",
    mask: "url(#mask58)"
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface182",
    mask: "url(#mask59)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.784314%,80.784314%,80.784314%)",
      fillOpacity: 1
    },
    d: "M 26.253906 95.589844 C 24.945312 96.878906 23.410156 97.816406 21.644531 98.398438 C 21.195312 98.902344 21.128906 99.371094 21.441406 99.800781 C 20.226562 100.277344 19.558594 101.144531 19.4375 102.40625 C 18.855469 102.378906 18.320312 102.511719 17.835938 102.804688 C 17.898438 102.144531 18.167969 101.609375 18.636719 101.203125 C 19.199219 101.011719 19.46875 100.613281 19.4375 100 C 21.132812 97.617188 23.402344 96.148438 26.253906 95.589844 Z M 26.253906 95.589844 "
  }), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface185",
    mask: "url(#mask60)"
  })), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface188",
    mask: "url(#mask61)"
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface191",
    mask: "url(#mask62)"
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface194",
    mask: "url(#mask63)"
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface197",
    mask: "url(#mask64)"
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface200",
    mask: "url(#mask65)"
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface203",
    mask: "url(#mask66)"
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface206",
    mask: "url(#mask67)"
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface209",
    mask: "url(#mask68)"
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface212",
    mask: "url(#mask69)"
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface215",
    mask: "url(#mask70)"
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface218",
    mask: "url(#mask71)"
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface221",
    mask: "url(#mask72)"
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface224",
    mask: "url(#mask73)"
  })), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface227",
    mask: "url(#mask74)"
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface230",
    mask: "url(#mask75)"
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface233",
    mask: "url(#mask76)"
  })), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface236",
    mask: "url(#mask77)"
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface239",
    mask: "url(#mask78)"
  })), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface242",
    mask: "url(#mask79)"
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface245",
    mask: "url(#mask80)"
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface248",
    mask: "url(#mask81)"
  })), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface251",
    mask: "url(#mask82)"
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface254",
    mask: "url(#mask83)"
  })), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface257",
    mask: "url(#mask84)"
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface260",
    mask: "url(#mask85)"
  })), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface263",
    mask: "url(#mask86)"
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface266",
    mask: "url(#mask87)"
  })), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface269",
    mask: "url(#mask88)"
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface272",
    mask: "url(#mask89)"
  })), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface275",
    mask: "url(#mask90)"
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface278",
    mask: "url(#mask91)"
  })), _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface281",
    mask: "url(#mask92)"
  })), _use94 || (_use94 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface284",
    mask: "url(#mask93)"
  })), _use95 || (_use95 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface287",
    mask: "url(#mask94)"
  })), _use96 || (_use96 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface290",
    mask: "url(#mask95)"
  })), _use97 || (_use97 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface293",
    mask: "url(#mask96)"
  })), _use98 || (_use98 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface296",
    mask: "url(#mask97)"
  })), _use99 || (_use99 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface299",
    mask: "url(#mask98)"
  })), _use100 || (_use100 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface302",
    mask: "url(#mask99)"
  })), _use101 || (_use101 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface305",
    mask: "url(#mask100)"
  })), _use102 || (_use102 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface308",
    mask: "url(#mask101)"
  })), _use103 || (_use103 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface311",
    mask: "url(#mask102)"
  })), _use104 || (_use104 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface314",
    mask: "url(#mask103)"
  })), _use105 || (_use105 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface317",
    mask: "url(#mask104)"
  })), _use106 || (_use106 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface320",
    mask: "url(#mask105)"
  })), _use107 || (_use107 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface323",
    mask: "url(#mask106)"
  })), _use108 || (_use108 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface326",
    mask: "url(#mask107)"
  })), _use109 || (_use109 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface329",
    mask: "url(#mask108)"
  })), _use110 || (_use110 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface332",
    mask: "url(#mask109)"
  })), _use111 || (_use111 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface335",
    mask: "url(#mask110)"
  })), _use112 || (_use112 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface338",
    mask: "url(#mask111)"
  })), _use113 || (_use113 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface341",
    mask: "url(#mask112)"
  })), _use114 || (_use114 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface344",
    mask: "url(#mask113)"
  })), _use115 || (_use115 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface347",
    mask: "url(#mask114)"
  })), _use116 || (_use116 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface350",
    mask: "url(#mask115)"
  })), _use117 || (_use117 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface353",
    mask: "url(#mask116)"
  })), _use118 || (_use118 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface356",
    mask: "url(#mask117)"
  })), _use119 || (_use119 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface359",
    mask: "url(#mask118)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDielectricConstant);
export default __webpack_public_path__ + "static/media/DielectricConstant.8589457851b5b62e267f5fec51e5917c.svg";
export { ForwardRef as ReactComponent };